import React from 'react';
import './bet-section.scss';

function SideBar({ children }) {
  return (
    <div className='cpt-betslip'>
      <div className='cpt-bet-section-wrapper'>{children}</div>
    </div>
  );
}
export default SideBar;
